import { render, staticRenderFns } from "./QueuedTransaction.vue?vue&type=template&id=40a1cc89"
import script from "./QueuedTransaction.vue?vue&type=script&lang=js"
export * from "./QueuedTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports